import React from 'react';
import {CustomUploadFile, FileUploader} from "../../../../../core/file-uploader/file-uploader";

export interface UIWidgetImageProps {
    upload: (file: File) => Promise<any>;
    value?: CustomUploadFile[];
    onChange?: (value: CustomUploadFile[]) => void;
    onRemove?: (value: CustomUploadFile) => Promise<any>;
}

export const UIInputWidgetImage: React.FC<UIWidgetImageProps> = ({value, onChange, onRemove, upload}) => {
    return (
        <FileUploader
            upload={upload}
            fileList={value || []}
            onFileListChanged={onChange || (() => null)}
            onRemove={onRemove}
            maxCount={1}
        />
    )
};